import React from 'react';

import { Box, Heading } from '@upstart/patina-design-system';

import { ConsentMarkdown } from '@atoms/ConsentMarkdown';
import { ConsentDataMimeType } from '@hooks/api/useFetchConsentData';
import { ConsentTag } from '@hooks/api/useStepState/types/fundingForm';
import { useBrandName } from '@hooks/useBrandName';
import { ConsentWrapper } from '@molecules/ConsentWrapper';
import { Container } from '@molecules/Container';
import { constVoid } from '@utils/function';

export const Document: React.FC<{ tag: ConsentTag }> = ({ tag }) => {
  const brandName = useBrandName();

  return (
    <Container>
      <ConsentWrapper
        consent={tag}
        trackEvent="viewed_at"
        onTrackConsentsCompleted={constVoid}
        trackForAllUsers={true}
      >
        {({ consentContent, mimeType, onConsentPresented }) => (
          <div className="mb-16 mt-8">
            <Box atoms={{ textAlign: 'center', marginBottom: 'xl' }}>
              <Heading component="h1" size="l" isNotPii>
                {brandName}
              </Heading>
            </Box>
            <DocumentRenderer
              mimeType={mimeType}
              content={consentContent}
              onPresented={onConsentPresented}
            />
          </div>
        )}
      </ConsentWrapper>
    </Container>
  );
};

const DocumentRenderer: React.FC<{
  mimeType: ConsentDataMimeType;
  content: string;
  onPresented: () => void;
}> = ({ onPresented, content, mimeType }) => {
  React.useEffect(() => {
    if (mimeType === 'text/uri-list') {
      window.location.href = content;
    }
  }, [mimeType]);

  if (mimeType === 'text/markdown') {
    return <ConsentMarkdown content={content} onPresented={onPresented} />;
  }

  return null;
};
